import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { IScheduleCData } from '../../types';

const { CONTROLLERS: { SCHEDULE_DATA: { VERSION, BASE } } } = USER;

export const useGetScheduleDataQuery = ({ customerId, onSuccess }: { customerId: string, onSuccess?: (data:IScheduleCData)=> void }) => useQuery(
  'ScheduleData',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`));
    return data;
  },
  {
    cacheTime: 0,
    enabled: false,
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
  },
);
